import { getTranscription } from './services';

const MIN_AUDIO_BYTES = 1024;

const getFileExtension = (mimeType) => {
  if (mimeType.includes('mp4')) return '.mp4';
  if (mimeType.includes('ogg')) return '.ogg';
  return '.webm';
};

const getSupportedMimeType = () => {
  const types = [
    'audio/webm;codecs=opus',
    'audio/ogg;codecs=opus',
    'audio/webm',
    'audio/mp4',
  ];
  return types.find(t => MediaRecorder.isTypeSupported(t)) || '';
};

const uploadAudio = async (blob, setTranscription) => {
  if (!blob || blob.size < MIN_AUDIO_BYTES) return;

  try {
    let formData = new FormData();
    const ext = getFileExtension(blob.type);
    formData.append('audio', blob, 'file_' + Date.now().toString() + ext);

    const transcription = await getTranscription(
      formData,
    );

    if(transcription) {
      setTranscription(transcription);
    }
  } catch (error) {
    console.error("Error uploading audio:", error);
  }
};

const startRecording = async (recorderRef, setTranscription) => {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const mimeType = getSupportedMimeType();
  const recorder = mimeType
    ? new MediaRecorder(stream, { mimeType })
    : new MediaRecorder(stream);
  const chunks = [];

  recorder.ondataavailable = (event) => {
    if (event.data.size > 0) chunks.push(event.data);
  };

  recorder.onstop = () => {
    const blob = new Blob(chunks, { type: recorder.mimeType });
    uploadAudio(blob, setTranscription);
    stream.getTracks().forEach((track) => track.stop());
  };

  recorder.start(1000);
  recorderRef.current = recorder;
};

const stopRecording = (recorderRef) => {
  const mediaRecorder = recorderRef.current;
  if (!mediaRecorder || mediaRecorder.state === "inactive") {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    mediaRecorder.addEventListener("stop", () => resolve(), { once: true });
    mediaRecorder.stop();
  });
};

export const startTimer = async (timerRef, recorderRef, setTranscription) => {
  await startRecording(recorderRef, setTranscription);
  let cycling = false;
  timerRef.current = setInterval(async () => {
    if (cycling) return;
    cycling = true;
    const timer = timerRef.current;
    try {
      await stopRecording(recorderRef);
      if (timerRef.current !== timer) return;
      await startRecording(recorderRef, setTranscription);
    } finally {
      cycling = false;
    }
  }, 7000);
}

export const stopTimer = (timerRef, recorderRef) => {
  clearInterval(timerRef.current);
  timerRef.current = null;
  stopRecording(recorderRef);
}
